<template>
    <b-modal id="metodosPagoNuevo"  title="Añadir nuevo método de pago" >
        <div id="card-element"></div>
        <div id="card-errors" role="alert"></div>
        <template #modal-footer>
            <b-button variant="info" v-if="!isProcessing" @click="$bvModal.hide('metodosPagoNuevo')">
                Cancelar
            </b-button>
            <b-button variant="primary" @click="handleSubmit" :disabled="isProcessing">
                <span v-if="!isProcessing">
                    <!-- <i class="fa fa-plus"></i> -->
                    Agregar método de pago
                </span>
                <span v-else>Procesando...</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from 'axios'

import { notify } from '@/utils'
import stripeObj from '@/stripe/stripeHandler'

export default {
    name: 'metodosPagoNuevo',
    data() {
        return {
            stripe: null,
            stripeElements: null,
            stripeCardElement: null,
            stripePaymentMethod: null,
            isProcessing: false,
            uniqueId: null
        };
    },
    methods: {
        createStripeElement() {
            // Crear instancia de Elements solo después de que el modal sea visible
            this.stripeElements = this.stripe.elements();

            // Crear el elemento de tarjeta
            this.stripeCardElement = this.stripeElements.create('card', { style: stripeObj.style });

            // Montar el elemento en el DOM
            this.stripeCardElement.mount('#card-element');

            // Manejar errores de validación en tiempo real
            this.stripeCardElement.addEventListener('change', (event) => {
                const displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });
        },
        open() {
            if (!this.stripe)
                this.stripe = stripeObj.initialize();
            this.$bvModal.show('metodosPagoNuevo');
            this.$nextTick(this.createStripeElement);
        },
        async handleSubmit() {
            if (this.isProcessing)
                return true;
            this.isProcessing = true;
            try {
                const pm = await this.processPMObj();
                if (!pm)
                    throw 'Token no recibido';
                const response = await axios.post('index.php?r=claveverde/stripeutils/addpm', {
                    payment_method_id: pm.id
                });

                if (response.status) {
                    this.$emit('paymentAdded', response);
                    this.$bvModal.hide('metodosPagoNuevo');
                    notify('Método de pago agregado exitosamente', 'success')
                } else {
                    throw response.msg || 'Error al agregar el método de pago';
                }
            } catch (e) {
                console.error(e);
                notify(e)
            }
            this.isProcessing = false;
        },
        async processPMObj() {
            let paymentMethod = null;
            const result = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeCardElement,
            })
            if (result.error) {
                // Handle error
                console.warn(result.error)
                throw result.error.message;
            } else {
                // PaymentMethod created successfully
                paymentMethod = result.paymentMethod;
                // Send paymentMethod.id to your server
            }
            return paymentMethod;
        },
    },
    beforeDestroy() {
        // Limpiar el elemento de tarjeta cuando el componente se destruye
        if (this.stripeCardElement) {
            this.stripeCardElement.unmount();
        }
    }
};
</script>

<style>
#card-element {
    margin-top: 20px;
    margin-bottom: 20px;
}

#card-errors {
    color: #fa755a;
    margin-top: 10px;
}
</style>